<script lang="ts" setup>
const { isAdmin } = storeToRefs(useAuthStore())
</script>

<template>
  <div class="flex flex-col gap-4">
    <RecyclerPendingResponseCard v-if="!isAdmin" />
    <CollectWithMissingFieldsCard />
    <CollectsToConfirmCard />
    <RoundsWithMissingAssignmentsCard />
  </div>

  <div v-if="!isAdmin" class="gap-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
    <IncomingCollectsCard class="col-span-2" />
    <AccountManager class="!w-full" />
  </div>

  <Dashboard v-if="featureFlags.wrMetabaseDashboard.value" />
</template>
